import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { i18n } from "./i18n";
import { createPinia } from "pinia";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import VueApexCharts from "vue3-apexcharts";
import Fancybox from './plugins/fancybox';
import "@/assets/font/stylesheet.css";
import "@/assets/scss/main.scss";
import 'floating-vue/dist/style.css'
import FloatingVue from 'floating-vue'
const app = createApp(App);
app.component("apexchart", VueApexCharts);
app.use(router);
app.use(createPinia());
app.use(i18n);
app.use(Fancybox)
app.component("VueDatePicker", VueDatePicker);
app.use(FloatingVue)
app.mount("#app");

// const localeStore = useLocaleStore();
// setI18nLocale(localeStore);
